import zhCN, { type TranslationKeys } from './zh-CN'
import enUS from './en-US'
import jaJP from './ja-JP'
import ruRU from './ru-RU'
import zhTW from './zh-TW'

// 支持的语言列表
export const SUPPORTED_LOCALES = [
  'en-US',
  'ja-JP',
  'ru-RU',
  'zh-CN',
  'zh-TW',
] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

// 语言资源映射
export const localeResources: Record<SupportedLocale, TranslationKeys> = {
  'en-US': enUS,
  'ja-JP': jaJP,
  'ru-RU': ruRU,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
}

// 默认语言
export const DEFAULT_LOCALE: SupportedLocale = 'en-US'

// 语言显示名称
export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  'en-US': 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  'ja-JP': '日本語',
  'ru-RU': 'Русский',
}

// 获取语言资源
export const getLocaleResource = (locale: string): TranslationKeys => {
  if (SUPPORTED_LOCALES.includes(locale as SupportedLocale)) {
    return localeResources[locale as SupportedLocale]
  }
  return localeResources[DEFAULT_LOCALE]
}

// 检查是否为支持的语言
export const isSupportedLocale = (
  locale: string
): locale is SupportedLocale => {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale)
}

// 导出语言资源
export { zhCN, enUS, jaJP, ruRU, zhTW }
export type { TranslationKeys }
